// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1oYvl","fileBtn":"File_fileBtn__2eM4A","closeBtn":"File_closeBtn__19k24","fileSelected":"File_fileSelected__1jce4","disabled":"File_disabled__2nzwN"};